import { useEffect, useLayoutEffect } from 'react';

import { canUseWindow } from '../utils/browser/canUseWindow';

// useLayoutEffect warns during SSR even when its body no-ops; fall back to useEffect on the server
// (where it never runs anyway) so client behaviour is unchanged and SSR stays quiet.
export const useIsomorphicLayoutEffect = canUseWindow() ? useLayoutEffect : useEffect;
